import React from 'react';
export function IntroSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-8" data-id="element-3228">
      <p className="text-xl text-navy font-bold leading-relaxed border-l-4 border-orange pl-6" data-id="element-3229">
        The problem is simple to define, but getting ahead of it can quickly
        become complex:{' '}
        <span className="font-normal italic text-gray-700" data-id="element-3230">
          "Manufacturers often focus only on equipment price when making
          return-on-investment (ROI) calculations and fail to evaluate the total
          life cycle cost or anticipated performance of the equipment."
        </span>
      </p>

      <div className="text-center" data-id="element-3231">
        <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/GFMS_Mikron%20MILL%20S%20400%20U%20-%20High%20Speed%205-Axis%20Machining%20Center.jpg" alt="GFMS_Mikron MILL S 400 U - High Speed 5-Axis Machining Center" className="block mx-auto max-w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3232" />
      </div>

      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-3233">
        The true cost of a vertical or horizontal machining center cannot be
        encompassed by its asking price. You have to consider operation,
        maintenance and decommission costs in any serious evaluation of the
        expenses and revenues generated by a particular machine.
      </p>
    </div>;
}